import React from 'react';
import BlogRoutes from './blog.routes';
import MainLayout from 'components/layouts/MainLayout';

const Blog = () => {
    return (
        <MainLayout>
            <BlogRoutes />
        </MainLayout>
    );
};

export default Blog;